// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-block__container {
	position: absolute;
	width: 400px;
	top: 48px;
	right: 0;
	background-color: white;
	border-radius: 10px;
	border: 1px solid #e6e6e6;
	padding: 24px;
	box-shadow: 0 0 18px 2px rgba(0, 0, 0, 0.1);
	z-index: 2;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.filter-block__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
}

.filter-block__title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 500;
	color: #191919;
}

.filter-block__close {
	cursor: pointer;
	width: 40px;
	height: 40px;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: 0.3s;
}

.filter-block__close:hover {
	background-color: #f2f2f2;
	transition: 0.3s;
}

.filter-block__buttons {
	display: flex;
	align-items: center;
	gap: 8px;
}

.filter-block__content {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
}

.filter-block__filter {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.filter-block__filter-title {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
}

.filter-block__filter-options {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-left: 8px;
}

.filter-block__filter-option {
	display: flex;
	align-items: center;
	gap: 8px;
}

.filter-block__filter-option-circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 1px solid #e6e6e6;
	cursor: pointer;
	transition: 0.3s;
}

.filter-block__filter-option-circle.selected {
	border: 1px solid #4db8ff;
	background-color: #4db8ff;
	transition: 0.3s;
	outline: 2px solid white;
	outline-offset: -4px;
}

.filter-block__filter-option-label {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
	font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/FilterBlock/FilterBlock.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,2CAA2C;CAC3C,UAAU;CACV,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB","sourcesContent":[".filter-block__container {\n\tposition: absolute;\n\twidth: 400px;\n\ttop: 48px;\n\tright: 0;\n\tbackground-color: white;\n\tborder-radius: 10px;\n\tborder: 1px solid #e6e6e6;\n\tpadding: 24px;\n\tbox-shadow: 0 0 18px 2px rgba(0, 0, 0, 0.1);\n\tz-index: 2;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.filter-block__header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.filter-block__title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.filter-block__close {\n\tcursor: pointer;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttransition: 0.3s;\n}\n\n.filter-block__close:hover {\n\tbackground-color: #f2f2f2;\n\ttransition: 0.3s;\n}\n\n.filter-block__buttons {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.filter-block__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\twidth: 100%;\n}\n\n.filter-block__filter {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.filter-block__filter-title {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n}\n\n.filter-block__filter-options {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tpadding-left: 8px;\n}\n\n.filter-block__filter-option {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.filter-block__filter-option-circle {\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 50%;\n\tborder: 1px solid #e6e6e6;\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\n.filter-block__filter-option-circle.selected {\n\tborder: 1px solid #4db8ff;\n\tbackground-color: #4db8ff;\n\ttransition: 0.3s;\n\toutline: 2px solid white;\n\toutline-offset: -4px;\n}\n\n.filter-block__filter-option-label {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n\tfont-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
